import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  body {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
      'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
      sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background-color: #f5f5f5;
  }

  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
      monospace;
  }

  button {
    cursor: pointer;
    font-family: inherit;
  }

  input, button, select, textarea {
    font-family: inherit;
  }

  /* Улучшение скроллинга на мобильных устройствах */
  * {
    -webkit-overflow-scrolling: touch;
  }

  /* Скрытие полосы прокрутки для горизонтальных скроллов */
  .horizontal-scroll {
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* Internet Explorer 10+ */
  }

  .horizontal-scroll::-webkit-scrollbar {
    display: none; /* WebKit */
  }

  /* Адаптивные breakpoints */
  @media (max-width: 768px) {
    body {
      font-size: 14px;
    }
  }

  @media (max-width: 480px) {
    body {
      font-size: 13px;
    }
  }

  /* Улучшение касаний на мобильных */
  button, a, [role="button"] {
    touch-action: manipulation;
  }

  /* Предотвращение зума при фокусе на инпуты на iOS */
  @media screen and (max-width: 768px) {
    input[type="text"],
    input[type="email"],
    input[type="number"],
    input[type="password"],
    input[type="tel"],
    input[type="url"],
    input[type="search"],
    textarea,
    select {
      font-size: 16px;
    }
  }

  /* Анимация для модального окна уведомлений */
  @keyframes fadeInScale {
    from {
      opacity: 0;
      transform: translate(-50%, -50%) scale(0.9);
    }
    to {
      opacity: 1;
      transform: translate(-50%, -50%) scale(1);
    }
  }

  /* Анимация пульсации для индикатора системной темы */
  @keyframes pulse {
    0%, 100% {
      opacity: 1;
      transform: scale(1);
    }
    50% {
      opacity: 0.7;
      transform: scale(1.1);
    }
  }

  /* CSS переменные для плавных переходов тем */
  :root {
    --transition-theme: all 0.3s ease;
    --transition-fast: all 0.15s ease;
    --transition-slow: all 0.5s ease;
  }

  /* Плавные переходы для всех элементов при смене темы, исключая интерактивные элементы */
  *:not(button):not(input):not(select):not(textarea):not([role="button"]), 
  *:not(button):not(input):not(select):not(textarea):not([role="button"])::before, 
  *:not(button):not(input):not(select):not(textarea):not([role="button"])::after {
    transition: background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease, 
                box-shadow 0.3s ease, opacity 0.3s ease;
  }

  /* Улучшение scrollbar для темной темы */
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  ::-webkit-scrollbar-track {
    background: var(--scrollbar-track, #f1f1f1);
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb {
    background: var(--scrollbar-thumb, #c1c1c1);
    border-radius: 4px;
    transition: background 0.3s ease;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: var(--scrollbar-thumb-hover, #a8a8a8);
  }

  /* Темная тема scrollbar */
  [data-theme="dark"] {
    --scrollbar-track: #2d2d2d;
    --scrollbar-thumb: #555555;
    --scrollbar-thumb-hover: #777777;
  }

  /* Светлая тема scrollbar */
  [data-theme="light"] {
    --scrollbar-track: #f1f1f1;
    --scrollbar-thumb: #c1c1c1;
    --scrollbar-thumb-hover: #a8a8a8;
  }

  /* Улучшение выделения текста */
  ::selection {
    background-color: var(--selection-bg, rgba(0, 123, 255, 0.2));
    color: var(--selection-color, inherit);
  }

  [data-theme="dark"] {
    --selection-bg: rgba(77, 171, 247, 0.3);
    --selection-color: #ffffff;
  }

  [data-theme="light"] {
    --selection-bg: rgba(0, 123, 255, 0.2);
    --selection-color: inherit;
  }
`;

export default GlobalStyle; 